// Copyright (c) 2016 Deere & Company

import {
    resetClaimHistoryReport,
    selectClaimHistoryClaimType,
    selectClaimHistoryDealer,
    selectCreditMemoProcessDate,
    updateClaimHistoryCriteria
} from './criteria';
import {createClaimHistoryReport} from './report';
import {readClaimTypes} from './read-claim-types';
import {sharedActionCreators} from '../../shared/action-creators';

export default {
    createClaimHistoryReport,
    readClaimTypes,
    resetClaimHistoryReport,
    selectClaimHistoryClaimType,
    selectClaimHistoryDealer,
    selectCreditMemoProcessDate,
    updateClaimHistoryCriteria,
    ...sharedActionCreators
};



// WEBPACK FOOTER //
// ./src/reports/claim-history/action-creators/index.js